import * as React from "react";
import Styled from "./styled";
import Lottie from "react-lottie";
import * as animationData from "@assets/animations/countdown.json";
import seloSeguro from "@assets/img/selo_seguro.png";
import { useSearchParams } from "react-router-dom";

const EmepagRedirect: React.FC = () => {
  let [searchParams] = useSearchParams();
  const emepagUrl = searchParams.get("url") ?? "";

  React.useEffect(() => {
    setTimeout(() => {
      window.location.href = emepagUrl;
    }, 10000);
    // eslint-disable-next-line
  }, []);

  return (
    <Styled.RootContainer>
      <h4>Você será redirecionado para a plataforma de pagamentos emepag.</h4>
      <Lottie options={{ loop: false, autoplay: true, animationData }} height={250} width={250} />
      <Styled.SafeSignImage src={seloSeguro} width={150} />
    </Styled.RootContainer>
  );
};

export default EmepagRedirect;
